import React from 'react';
import { OfferRequisitionFeed } from '../../../../../entities/ApplicationFeed';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { AlertObject } from '../../../../../components/Alert';
import { GenericEntry } from '../..';
import { getNounWithPossessiveCase } from '../../../../../utils/grammar';
import { ViewRequisitionButton } from '../ViewRequisitionButton';

interface PropTypes {
  application: Application;
  currentUser: User;
  isLastItemInPage: boolean;
  entry: OfferRequisitionFeed;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function OfferRequisitionDeclined(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-file-medical'
      iconClassName='bg-blue-gray-light'
      title={
        <span>
          <strong>{getNounWithPossessiveCase(props.entry.authorName)}</strong>{' '}
          offer requisition for{' '}
          <strong>
            {getNounWithPossessiveCase(props.application.candidate.name)}
          </strong>{' '}
          was declined.
        </span>
      }
      date={props.entry.createdAt}
      {...props}
    >
      <ViewRequisitionButton entry={props.entry} />
    </GenericEntry>
  );
}
